import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Bookmark } from '../models/bookmark.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiListResponse } from '../models/general.models';

@Injectable({
  providedIn: 'root'
})
export class BookmarkService {
  private baseUrl: string = environment.baseUrl;
  constructor(private http: HttpClient) {}

  public createBookmark(body: Partial<Bookmark>, project_id: string): Observable<Bookmark> {
    const endpoint = `${this.baseUrl}/projects/${project_id}/bookmarks`;
    return this.http.post<Bookmark>(endpoint, body);
  }

  public updateBookmark(body: Partial<Bookmark>, project_id: string, bookmark_id: string): Observable<Bookmark> {
    const endpoint = `${this.baseUrl}/projects/${project_id}/bookmarks/${bookmark_id}`;
    return this.http.patch<Bookmark>(endpoint, body);
  }

  public getAllBookmarks(queryKeys: { [key: string]: any; }): Observable<ApiListResponse<Bookmark>> {
    let endpoint = `${this.baseUrl}/bookmarks`;
    Object.keys(queryKeys).forEach((key, index) => {
      if (queryKeys[key]) {
        const jointer = index === 0 ? '?' : '&';
        endpoint += `${jointer}${key}=${queryKeys[key]}`;
      }
    });
    return this.http.get<ApiListResponse<Bookmark>>(endpoint);
  }

  public getBookmarksById(project_id: string): Observable<ApiListResponse<Bookmark>> {
    const endpoint = `${this.baseUrl}/projects/${project_id}/bookmarks`;
    return this.http.get<ApiListResponse<Bookmark>>(endpoint);
  }

  public deleteBookmark(filter: { [key: string]: any; }): Observable<{ [key: string]: any; }> {
    return this.http.post<{ [key: string]: any; }>(`${this.baseUrl}/bookmarks/bulk-delete`, filter);
  }
}
